import { render, staticRenderFns } from "./DisplayKindSP.vue?vue&type=template&id=5181ea1c&scoped=true&"
import script from "./DisplayKindSP.vue?vue&type=script&lang=js&"
export * from "./DisplayKindSP.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindSP.vue?vue&type=style&index=0&id=5181ea1c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181ea1c",
  null
  
)

export default component.exports